export default function buildFormulaItemObj(item) {
	return { id: item.id, eav_template_id: item.eav_template_id }
}
